import React from 'react'

import { Button, Grid } from '@mui/material'
import { useCustomerWorkflows } from 'features/customers/hooks/useCustomerWorkflows'
import { sortBy } from 'lodash'
import { useFormContext } from 'react-hook-form'

import { FormDateTimePicker, FormSelect } from 'components/input'
import FormTextField from 'components/input/FormTextField'

const CustomerAuditFilters = () => {
  const { setValue } = useFormContext()
  const { data } = useCustomerWorkflows()

  // Refresh re-runs the audit query against the current "to" time.
  const handleRefresh = (e: React.FormEvent) => {
    e.preventDefault()
    setValue('date_to', new Date())
  }

  const options = sortBy(data?.workflows, ({ type }) => type).map(item => ({
    value: item.id,
    label: `[${item.type}] ${item.name}`,
  }))

  return (
    <form onSubmit={handleRefresh} style={{ width: '800px' }}>
      <Grid container spacing={2} sx={{ alignItems: 'center', ml: '1rem' }}>
        <Grid
          size={{
            sm: 6,
          }}>
          <FormTextField label="Lead UUID" name="uuid" />
        </Grid>
        <Grid
          size={{
            sm: 6,
          }}>
          <FormSelect label="Customer Workflow" name="workflow_id" options={options} />
        </Grid>
        <Grid
          size={{
            sm: 5,
          }}>
          <FormDateTimePicker label="Date from" name="date_from" />
        </Grid>
        <Grid
          size={{
            sm: 5,
          }}>
          <FormDateTimePicker label="Date to" name="date_to" />
        </Grid>
        <Grid
          size={{
            sm: 2,
          }}>
          <Button type="submit" variant="outlined">
            Refresh
          </Button>
        </Grid>
      </Grid>
    </form>
  )
}

export default CustomerAuditFilters
